import React from "react";

import { Typography } from "@mui/material";

import {
  ColumnItem,
  FeatureToggle
} from "../../models/app-data-model";
import AccordionGroup from "../accordion-group/accordion-group/AccordionGroup";
import Button from "../button/Button";
import CompareGroup from "../compare-group/CompareGroup";
import EmbeddableContent from "../embeddable-content/EmbeddableContent";
import Media from "../media/Media";
import UserPathGroup from "../user-path-group/UserPathGroup";
import RichTextBlock from "../rich-text-block/RichTextBlock";

export type ColumnContentBlockProps = {
  columnItem: ColumnItem;
  featureToggles: FeatureToggle[];
};

export type headingVariant = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';

const ColumnContentBlock: React.FC<ColumnContentBlockProps> = ({ columnItem, featureToggles }: ColumnContentBlockProps) => {
  const variant = columnItem.heading?.heading_type as headingVariant;
  const rendering = (
    <>
      {columnItem.media && (
        <Media mediaData={columnItem.media}/>
      )}
      {columnItem.heading?.headline && (
        <Typography variant={variant}>{columnItem.heading?.headline}</Typography>
      )}
      {columnItem.rich_text?.copy && (
        <RichTextBlock content={columnItem.rich_text?.copy} />
      )}
      {columnItem.button?.label && (
        <Button className={columnItem.button.button_type} label={columnItem.button?.label} reference={columnItem.button?.reference} link={columnItem.button?.link} />
      )}
      {columnItem.accordion_group && (
        <AccordionGroup accordionGroup={columnItem.accordion_group} />
      )}
      {columnItem.user_path_group && (
        <UserPathGroup user_path_group={columnItem.user_path_group} />
      )}
      {columnItem.embeddable_content && (
        <EmbeddableContent embedContentData={columnItem.embeddable_content} featureToggles={featureToggles} />
      )}
      {columnItem.compare_group && (
        <CompareGroup content={columnItem.compare_group?.content} />
      )}
    </>
  );

  return rendering;
};

export default ColumnContentBlock;
